// src/components/Login.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.message || "خطأ في تسجيل الدخول");
        return;
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("role", data.user.role);

      if (data.user.role === "admin") navigate("/admin-dashboard");
      else if (data.user.role === "hotel") navigate("/hotel-dashboard");
      else if (data.user.role === "delivery") navigate("/dashboard/drivers");
      else alert("🚫 غير مصرح لك بالدخول!");
    } catch (err) {
      console.error(err);
      alert("خطأ في الاتصال بالسيرفر");
    }
  };

  return (
    <div className="login-page">
      {/* العنوان */}
      <h1 className="page-title">لوحة التحكم</h1>

      {/* الكارد */}
      <div className="login-card">
        <h2>تسجيل الدخول (Admin)</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>البريد الإلكتروني</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="example@email.com"
              required
            />
          </div>

          <div className="form-group">
            <label>كلمة المرور</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          <button type="submit" className="login-button">
            تسجيل الدخول
          </button>
        </form>

        {/* تبديل الأدوار */}
        <div className="role-switcher">
          <p>أو سجل الدخول كـ</p>
          <div className="switcher-actions">
            <button
              type="button"
              className="switcher-btn hotel-btn"
              onClick={() => navigate("/login-hotel")}
            >
              🏨 فندق
            </button>
            <button
              type="button"
              className="switcher-btn delivery-btn"
              onClick={() => navigate("/login-delivery")}
            >
              🚚 توصيل
            </button>
          </div>
        </div>
      </div>

      {/* CSS */}
      <style>{`
        .login-page {
          min-height: 100vh;
          background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-family: 'Segoe UI', Tahoma, sans-serif;
        }

        .page-title {
          margin-bottom: 25px;
          font-size: 32px;
          font-weight: bold;
          color: #333;
          text-align: center;
        }

        .login-card {
          width: 100%;
          max-width: 380px;
          background: white;
          padding: 25px;
          border-radius: 12px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        }

        .login-card h2 {
          text-align: center;
          margin-bottom: 20px;
          color: #444;
        }

        .form-group {
          margin-bottom: 15px;
        }

        .form-group label {
          display: block;
          margin-bottom: 6px;
          font-size: 14px;
          color: #555;
        }

        .form-group input {
          width: 100%;
          padding: 10px;
          border-radius: 6px;
          border: 1px solid #ccc;
          font-size: 14px;
          outline: none;
        }

        .form-group input:focus {
          border-color: #007bff;
        }

        .login-button {
          width: 100%;
          padding: 11px;
          margin-top: 10px;
          background-color: #007bff;
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 15px;
          font-weight: bold;
          cursor: pointer;
        }

        .login-button:hover {
          background-color: #0056b3;
        }

        .role-switcher {
          margin-top: 20px;
          padding-top: 15px;
          border-top: 1px solid #eee;
          text-align: center;
        }

        .role-switcher p {
          font-size: 14px;
          color: #666;
          margin-bottom: 10px;
        }

        .switcher-actions {
          display: flex;
          justify-content: center;
          gap: 10px;
        }

        .switcher-btn {
          padding: 8px 16px;
          border: none;
          border-radius: 20px;
          cursor: pointer;
          font-weight: bold;
          font-size: 14px;
        }

        .hotel-btn {
          background-color: #ffc107;
          color: #333;
        }

        .hotel-btn:hover {
          background-color: #e0a800;
        }

        .delivery-btn {
          background-color: #28a745;
          color: white;
        }

        .delivery-btn:hover {
          background-color: #1e7e34;
        }
      `}</style>
    </div>
  );
}
